export default __webpack_public_path__ + "static/media/Coronal Boots.2f1c24dd.jpg";